"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importStar(require("react"));
var antd_1 = require("antd");
var styled_components_1 = __importDefault(require("styled-components"));
var core_1 = require("@rjsf/core");
// @ts-ignore
var antd_2 = require("@rjsf/antd");
var RevDateTimeToTimeStampPicker_1 = __importDefault(require("./CustomWidgets/RevDateTimeToTimeStampPicker"));
var RevArticleWidget_1 = __importDefault(require("./CustomWidgets/RevArticleWidget"));
var RevSingleImageUploader_1 = __importDefault(require("./CustomWidgets/RevSingleImageUploader"));
var RevMultipleImageUploader_1 = __importDefault(require("./CustomWidgets/RevMultipleImageUploader"));
var RjsForm = core_1.withTheme(antd_2.Theme);
function Form(props) {
  var schema = props.schema,
    uiSchema = props.uiSchema,
    instance = props.instance,
    _a = props.onSubmit,
    onSubmit = _a === void 0 ? null : _a,
    renderCustomSubmitButton = props.renderCustomSubmitButton,
    renderCustomSection = props.renderCustomSection;
  var _b = react_1.default.useState(instance || {}),
    values = _b[0],
    setValues = _b[1];
  var _c = react_1.default.useState({}),
    extValues = _c[0],
    setExtValues = _c[1];
  var submitBtnRef = react_1.default.useRef(null);
  var submitButton = react_1.default.useMemo(function () {
    if (renderCustomSubmitButton !== undefined) {
      if (typeof renderCustomSubmitButton === 'function') {
        return renderCustomSubmitButton({
          instance: instance,
          values: values,
          setValues: setValues,
          extValues: extValues,
          setExtValues: setExtValues
        }, submitBtnRef);
      }
      if (renderCustomSubmitButton === null) {
        return null;
      }
    }
    return react_1.default.createElement(antd_1.Button, {
      type: "primary",
      onClick: function () {
        var _a;
        (_a = submitBtnRef.current) === null || _a === void 0 ? void 0 : _a.click();
      }
    }, "\u78BA\u8A8D");
  }, [extValues, instance, renderCustomSubmitButton, values]);
  var widgets = react_1.useMemo(function () {
    return {
      'rev-datetime-to-timestamp-picker': function (props) {
        return react_1.default.createElement(RevDateTimeToTimeStampPicker_1.default, __assign({}, props));
      },
      'rev-article-widget': function (props) {
        return react_1.default.createElement(RevArticleWidget_1.default, __assign({}, props));
      },
      'rev-single-image-uploader': function (props) {
        return react_1.default.createElement(RevSingleImageUploader_1.default, __assign({}, props));
      }
    };
  }, []);
  var fields = {
    'rev-images': function (props) {
      return react_1.default.createElement(RevMultipleImageUploader_1.default, __assign({}, props));
    }
  };
  return react_1.default.createElement(Wrapper, null, renderCustomSection && renderCustomSection({
    position: 'top',
    instance: instance,
    values: values,
    setValues: setValues,
    extValues: extValues,
    setExtValues: setExtValues
  }), react_1.default.createElement(RjsForm, {
    schema: schema,
    uiSchema: uiSchema,
    widgets: widgets,
    fields: fields,
    formData: values,
    onChange: function (_a) {
      var formData = _a.formData;
      setValues(formData);
    },
    onSubmit: function (_a) {
      var formData = _a.formData;
      onSubmit(formData, extValues);
    },
    onError: function (errors) {
      console.log('errors', errors);
    }
  }, renderCustomSection && renderCustomSection({
    position: 'bottom',
    instance: instance,
    values: values,
    setValues: setValues,
    extValues: extValues,
    setExtValues: setExtValues
  }), react_1.default.createElement("div", {
    className: "submit-buttons-bar"
  }, submitButton, react_1.default.createElement("button", {
    type: "submit",
    ref: submitBtnRef
  }))));
}
var Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  max-width: 800px;\n  & .submit-buttons-bar {\n    display: flex;\n    justify-content: flex-end;\n    & button[type='submit'] {\n      display: none;\n    }\n  }\n"], ["\n  max-width: 800px;\n  & .submit-buttons-bar {\n    display: flex;\n    justify-content: flex-end;\n    & button[type='submit'] {\n      display: none;\n    }\n  }\n"])));
exports.default = Form;
var templateObject_1;